/***************** MENUS STUFF ******************/


jQuery(document).ready(function($) {
  $(document).on("show.zf.dropdownmenu", function(ev, $el) {
    //console.log("dropdown menu show "+ev.target.id+" / "+$el.attr('id'));
    if (ev.target.id=='menu-primary-navigation') {
      $('.desktop-menu').addClass('submenu-active');
    }
  });
  $(document).on("hide.zf.dropdownmenu", function(ev, $el) {
    console.log("dropdown menu show "+ev.target.id+" / "+$el.attr('id'));
    if (ev.target.id=='menu-primary-navigation') {
      $('.desktop-menu').removeClass('submenu-active');
    }
  });

  /***************** Position Sub Menu Items ******************/

  function positionSubMenus() {
    if (Foundation.MediaQuery.atLeast('smallx')) {
      var desktopMenu = $('.desktop-menu');
      var desktopMenuWidth = desktopMenu.width();
      var desktopMenuOffset = desktopMenu.offset();
      var scrollTop = $(window).scrollTop();
      var menuTop = desktopMenuOffset.top - scrollTop;
      var menuLeft = desktopMenuOffset.left + desktopMenuWidth;
      console.log('menuTop: ' + menuTop + ' - menuLeft: ' + menuLeft);
      $( ".desktop-menu .is-dropdown-submenu" ).each(function( index ) {
          $(this).css({
            'top' : menuTop + 'px',
            'left' : menuLeft + 'px',
          });
      });
    }
  }

  $(window).resize(function(){
    positionSubMenus();
  });

  $('#menu-reveal').on('open.zf.reveal',function() { // Must be run when menu open as doesn't work on hidden elements
    $('body').addClass('is-menu-open');
    $('.toggle').toggleClass('open');
    setTimeout(function() {
      positionSubMenus();
    },120);
  });
  $('#menu-reveal').on('closed.zf.reveal',function() { // Must be run when menu open as doesn't work on hidden elements
    $('body').removeClass('is-menu-open');
    $('.toggle').toggleClass('open');
  });


});
